module.exports = "\n <zingchart-angular [config]=\"myConfiges\" [height]=\"230\"></zingchart-angular>"